var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7315 2.2165C3.63878 1.43034 4.79949 0.99833 6 1C8.7615 1 11 3.2385 11 6C11 7.068 10.665 8.058 10.095 8.87L8.5 6H10C10.0001 5.21582 9.76962 4.44891 9.33733 3.79463C8.90504 3.14036 8.28997 2.62758 7.56859 2.32007C6.84721 2.01255 6.05136 1.92386 5.27998 2.06501C4.5086 2.20617 3.79573 2.57095 3.23 3.114L2.7315 2.2165ZM9.2685 9.7835C8.36122 10.5697 7.20051 11.0017 6 11C3.2385 11 1 8.7615 1 6C1 4.932 1.335 3.942 1.905 3.13L3.5 6H2C1.99994 6.78419 2.23038 7.5511 2.66267 8.20538C3.09496 8.85965 3.71003 9.37243 4.43141 9.67994C5.15279 9.98746 5.94864 10.0762 6.72002 9.935C7.4914 9.79384 8.20427 9.42905 8.77 8.886L9.2685 9.7835Z",
    fill: "#19AB4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progress_icon.33f812c2f0bb585da5c8388648d4c2f8.svg";
export { ForwardRef as ReactComponent };